export default {
    backgroundColor: '#E3E4E5',
    // padding: '2px 8px',
};
